var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"layout_default_container"},[_c('Header'),_c(_vm.currentComponent,{tag:"component"}),_c('createProject'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }